import { roleLabel } from "../lib/labels";
import { useMe } from "../lib/session";

/** Placeholder until the first connector lands (M1.3 MaintainX, M1.4 Geotab). */
export function Overview() {
  const me = useMe();
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="font-display text-3xl font-bold tracking-tight">{me.tenant.name}</h1>
        <p className="mt-1 text-muted">Signed in as {me.user.email} · {roleLabel(me.user.role)}{me.user.isSuperAdmin ? " · super admin" : ""}</p>
      </div>
      <section aria-labelledby="next" className="rounded-xl border border-line bg-card p-5">
        <h2 id="next" className="font-medium">Your fleet will appear here</h2>
        <p className="mt-2 text-muted">
          Units, locations and work orders arrive as the MaintainX and Geotab connectors are switched on.
        </p>
      </section>
    </div>
  );
}
